import Vue from 'vue'
import './styles/quasar.sass'
import lang from 'quasar/lang/fa-ir.js'
import '@quasar/extras/material-icons/material-icons.css'
import Quasar from 'quasar/src/vue-plugin.js';import QUploader from 'quasar/src/components/uploader/QUploader.js';import Notify from 'quasar/src/plugins/Notify.js';import Meta from 'quasar/src/plugins/Meta.js';import LoadingBar from 'quasar/src/plugins/LoadingBar.js';import QIcon from 'quasar/src/components/icon/QIcon.js';import QForm from 'quasar/src/components/form/QForm.js';import Dialog from 'quasar/src/plugins/Dialog.js';import Loading from 'quasar/src/plugins/Loading.js';

Vue.use(Quasar, {
    component: {
        QUploader,
        QIcon,
        QForm
    },
    config: {
        Notify,
        Meta,
        LoadingBar,
        Loading
    },
    plugins: {
        Notify,
        Meta,
        LoadingBar,
        Dialog,
        Loading
    },
    framework: {
        iconSet: 'mdi-v5'
    },
    lang: lang
});

LoadingBar.setDefaults({
    color:'yellow',
    size:'5px',
    position:'top'
})
